<div class="share-card">
    <div class="row align-items-start share-header">
        <div class="col-md-8">
            <h5>{{header}}</h5>
            <p>{{subHeader}}</p>
        </div>
        <div class="col-md-4 text-end">
            <div #qrCode></div>
        </div>
    </div>
    <!-- Top-right close button -->
<button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
  ×
</button>
    <div class="social-icons" style="cursor: pointer;">
        <a class="social-item" (click)="openModal('whatsapp')">
            <div class="icon" style="background:#DEFFEB; color:#1B9B0F;">
                <i class="bi bi-whatsapp"></i>
            </div>
            <span style="color:#1B9B0F;">WhatsApp</span>
        </a>
        <a class="social-item" (click)="openModal('email')">
            <div class="icon" style="background:#FACDCA; color:#FF4A3D;">
                <i class="bi bi-envelope-fill"></i>
            </div>
            <span style="color:#FF4A3D;">Email</span>
        </a>
        <a class="social-item" (click)="openModal('message')">
            <div class="icon" style="background:#E4F6FF; color:#4FB2FC;">
                <i class="bi bi-chat-dots-fill"></i>
            </div>
            <span style="color:#4FB2FC;">Message</span>
        </a>
        <a class="social-item" (click)="openModal('facebook')">
            <div class="icon" style="background:#DEEBFF; color:#0000FE;">
                <i class="bi bi-facebook"></i>
            </div>
            <span style="color:#0000FE;">Facebook</span>
        </a>
        <a class="social-item" (click)="openModal('messenger')">
            <div class="icon" style="background:#D1E2FD; color:#448AFF;">
                <i class="bi bi-messenger"></i>
            </div>
            <span style="color:#448AFF;">Messenger</span>
        </a>
        <a class="social-item" (click)="openModal('instagram')">
            <div class="icon" style="background:#FFD4F6; color:#C139AB;">
                <i class="bi bi-instagram"></i>
            </div>
            <span style="color:#C139AB;">Instagram</span>
        </a>
        <a class="social-item" (click)="openModal('twitter')">
            <div class="icon" style="background:#D1ECFE; color:#1D9BF0;">
                <i class="bi bi-twitter"></i>
            </div>
            <span style="color:#1D9BF0;">Twitter</span>
        </a>
        <a class="social-item" (click)="openModal('embed')">
            <div class="icon" style="background:#CEE7FA; color:#0078D4;">
                <i class="bi bi-code-slash"></i>
            </div>
            <span style="color:#0078D4;">Embed</span>
        </a>
    </div>

    <!-- AI-Generated Ad Message + Link Textarea (Visible only for admin) -->
    <div *ngIf="access === 'admin'" class="mt-3">
        <label for="adMessage">Promotional Message (AI-Generated)</label>
        <textarea id="adMessage" class="form-control ai-textarea" [formControl]="adMessageControl" maxlength="500"
            [class.ai-generating]="isGeneratingMessage" [rows]="4" [readonly]="isGeneratingMessage"
            (input)="updateMessageCharCount()"></textarea>
        <!-- <small class="text-muted">{{ messageCharCount }}/500 characters</small> -->

        <div class="descControllers text-end">
            <div class="button-group gap-2">
                <button type="button" class="ai-button generate-btn" *ngIf="(adMessageControl.value?.length || 0) === 0"
                    [disabled]="isGeneratingMessage"
                    [ngStyle]="{ cursor: isGeneratingMessage ? 'not-allowed' : 'pointer' }"
                    (click)="generateAdMessageWithAI()">
                    <div class="particles"></div>
                    <i class="fa-solid fa-wand-magic-sparkles"></i> Generate with AI
                </button>

                <button type="button" class="ai-button improve-btn" *ngIf="(adMessageControl.value?.length || 0) > 0"
                    [disabled]="isGeneratingMessage"
                    [ngStyle]="{ cursor: isGeneratingMessage ? 'not-allowed' : 'pointer' }"
                    (click)="improveAdMessageWithAI()">
                    <i class="fa-solid fa-wand-magic"></i> Improve with AI
                </button>

                <button type="button" class="ai-button copy-btn" (click)="copyLink()" [class.copied]="copied">
                    <i class="bi" [ngClass]="copied ? 'bi-check-lg' : 'bi-copy'"></i> {{ copied ? 'Copied' : 'Copy' }}
                </button>
            </div>

        </div>
    </div>

    <div class="copy-link mt-3" *ngIf="access === 'user'">
        <input type="text" [value]="link" readonly>
        <button (click)="copyLink()" [class.copied]="copied" [disabled]="isGeneratingMessage" [ngStyle]="{ cursor: isGeneratingMessage ? 'wait' : 'pointer' }" >
            <i class="bi" [ngClass]="copied ? 'bi-check-lg' : 'bi-copy'"></i>
        </button>
    </div>

</div>